import { render, staticRenderFns } from "./address.vue?vue&type=template&id=792f83d7"
import script from "./address.vue?vue&type=script&lang=js"
export * from "./address.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LoginModal: require('/vercel/path0/components/loginModal.vue').default,Field: require('/vercel/path0/components/ui/field.vue').default,SingleSelect: require('/vercel/path0/components/ui/singleSelect.vue').default,PrimaryButton: require('/vercel/path0/components/ui/primaryButton.vue').default})
